import { useState, FC } from 'react'

import { Button as MerinioButton } from 'ui'

import { t, currentLang } from 'translations'

// Component to return a viewMore/viewLess button if there are too many attributes showing
type Props = {
  parsedValues: string[]
  hideOverflow: number
  delimiter: string
  hideButton?: boolean
  isComment?: boolean
}

const HideOverflow: FC<Props> = ({ parsedValues, hideOverflow, delimiter, hideButton, isComment }) => {
  const currentLanguage = currentLang()
  const displayCommentTranslations = currentLanguage === 'en' && isComment
  const viewMoreTranslation = displayCommentTranslations ? 'READ_MORE' : 'VIEW_MORE'
  const viewLessTranslation = displayCommentTranslations ? 'READ_LESS' : 'VIEW_LESS'

  const [viewMore, setViewMore] = useState(false)

  return (
    <div>
      <p className="text-preline text-break mb-1">
        {parsedValues.slice(0, viewMore ? undefined : hideOverflow).join(delimiter)} {hideButton ? '[...]' : null} {!viewMore && !hideButton ? '...' : null}
      </p>
      {parsedValues.length > hideOverflow && !hideButton ? (
        <MerinioButton isLink onClick={() => setViewMore(state => !state)}>
          <div className="d-flex flex-row align-items-center mb-1">
            <small className="mb-1">{t(`components.${viewMore ? viewLessTranslation : viewMoreTranslation}`)}</small>
            {viewMore ? <i className="fa-solid fa-angle-up ml-1"></i> : <i className="fa-solid fa-angle-down ml-1"></i>}
          </div>
        </MerinioButton>
      ) : null}
    </div>
  )
}

export default HideOverflow
